import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface GuestAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  guestProgress: {
    lessonsCompleted: number;
    xp: number;
    streak: number;
  };
}

const GuestAccountModal: React.FC<GuestAccountModalProps> = ({ isOpen, onClose, guestProgress }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 20000,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '30px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{ fontSize: '48px', marginBottom: '10px' }}>💾</div>
          <h2 style={{ margin: '0 0 10px 0', fontSize: '24px', fontWeight: '700', color: '#1a1a1a' }}>
            Save Your Progress
          </h2>
          <p style={{ margin: '0', color: '#666', fontSize: '14px', lineHeight: '1.6' }}>
            Create an account to keep your progress safe and access it from any device.
          </p>
        </div>

        {/* Progress Summary - Only show if there's meaningful progress */}
        {(guestProgress.lessonsCompleted > 0 || guestProgress.xp > 0 || guestProgress.streak > 0) && (
          <div style={{
            background: '#f8f9fa',
            borderRadius: '12px',
            padding: '15px',
            marginBottom: '20px'
          }}>
            <p style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: '600', color: '#333' }}>
              Your current progress:
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-around', gap: '10px' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: '#6B46C1' }}>
                  {guestProgress.lessonsCompleted}
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>Lessons</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: '#6B46C1' }}>
                  {guestProgress.xp}
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>XP</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: '#6B46C1' }}>
                  {guestProgress.streak}
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>Streak</div>
              </div>
            </div>
          </div>
        )}

        {/* Benefits */}
        <div style={{ marginBottom: '20px' }}>
          <p style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: '600', color: '#333' }}>
            With an account, you can:
          </p>
          <ul style={{ margin: '0', paddingLeft: '20px', color: '#666', fontSize: '14px', lineHeight: '1.8' }}>
            <li>Access your progress from any device</li>
            <li>Never lose your learning streak</li>
            <li>Sync across multiple devices</li>
            <li>Join the leaderboard</li>
          </ul>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button
            onClick={() => {
              // Clear guest flag and dismissed flag before navigating
              localStorage.removeItem('isGuest');
              localStorage.removeItem('guestModalDismissed');
              onClose();
              // Small delay to ensure state updates
              setTimeout(() => {
                navigate('/register');
              }, 100);
            }}
            style={{
              padding: '14px',
              background: 'linear-gradient(135deg, #6B46C1 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(107, 70, 193, 0.3)'
            }}
          >
            Create Account
          </button>
          
          <button
            onClick={() => {
              // Clear guest flag and dismissed flag before navigating
              localStorage.removeItem('isGuest');
              localStorage.removeItem('guestModalDismissed');
              onClose();
              // Small delay to ensure state updates
              setTimeout(() => {
                navigate('/login');
              }, 100);
            }}
            style={{
              padding: '14px',
              background: 'transparent',
              color: '#6B46C1',
              border: '2px solid #6B46C1',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Sign In
          </button>
          
          <button
            onClick={() => {
              // Mark modal as dismissed and record time
              localStorage.setItem('guestModalDismissed', 'true');
              localStorage.setItem('guestModalLastShown', Date.now().toString());
              onClose();
            }}
            style={{
              padding: '10px',
              background: 'transparent',
              color: '#666',
              border: 'none',
              fontSize: '14px',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            Continue as Guest
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestAccountModal;

